(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/news-tt/assets/news-tt-actions.js') >= 0) return;  svs.modules.push('/components/sportinfo/news-tt/assets/news-tt-actions.js');
"use strict";


const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk;
const ContentUrlBuilder = svs.content.shared.ContentUrlBuilder;
const jupiter = svs.core.jupiter;
const fetchNewsFromJupiter = matchId => {
  const useCmsApi = svs.core.detect.feature('ft-use-cms-api-client-lb') && svs.core.detect.feature('ft-use-partner-cms-api');
  if (!useCmsApi) {
    const path = new ContentUrlBuilder('basicfilter', 'partner').addParams({
      parentId: 'svs-workarea-articles-news',
      domainCategories: "svs-domain-sport-events/".concat(matchId),
      sort: 'published:desc',
      count: 100
    }).build();
    return new Promise((resolve, reject) => {
      jupiter.get(path, response => {
        resolve(response.result);
      }, error => {
        reject(error);
      });
    });
  }

  const createCmsClient = svs.components.libs.CmsApiClient.createCmsClient;
  const svsFetchBaseUri = svs.core.config.data.svsconfig.svsFetchBaseUri;
  const partnerBaseUrl = "".concat(svsFetchBaseUri, "/partner");
  const svsFetch = svs.core.svsFetch.create({
    baseUrl: partnerBaseUrl
  });
  const client = createCmsClient({
    fetch: svsFetch
  });
  return client.v1.content.filter({
    parentIds: 'svs-workarea-articles-news',
    domainCategoryQuery: "svs-domain-sport-events=".concat(matchId),
    sort: ['published;desc'],
    count: 100
  }).then(response => response.result);
};
const fetchNews = createAsyncThunk('news-tt/fetchNews', async matchId => fetchNewsFromJupiter(matchId));
setGlobal('svs.components.sportinfo.newsTT.actions', {
  fetchNews
});

 })(window);